// Who was signed in during the previous session.
//
// Firebase Auth cannot answer this without a network round trip: on startup it
// restores the user from IndexedDB and then re-validates it against
// identitytoolkit (plus a token refresh, since ID tokens live only an hour)
// before onAuthStateChanged fires. That leaves the app behind a spinner for
// about a second even though the Firestore cache is warm.
//
// Remembering the uid ourselves lets the self-doc listener start at mount, so
// the cached profile opens the app gate immediately. The real auth state lands
// shortly after and corrects anything stale.

import { storageLastUid } from './consts';

export const readLastUid = () => {
  try {
    return localStorage.getItem(storageLastUid);
  } catch {
    return null;
  }
};

export const writeLastUid = (uid) => {
  try {
    if (uid) localStorage.setItem(storageLastUid, uid);
    else localStorage.removeItem(storageLastUid);
  } catch {}
};
